import { AppRoutes } from '@repo/web-utils/app-routes'
import { IconFeaturedSeasonalAndGifts } from '@repo/design-system-cf/components/icons'

import { useHeaderContext, useTranslations } from '../contexts/header-config-context'
import type { NavItemType } from './use-menu-items'

interface NavItem {
  id?: NavItemType
  name: string
  link: string
  target?: string
  icon?: React.ReactNode
  track?: () => void
  subMenuItems?: NavItem[]
}

export const useSecondaryNavItems = () => {
  const t = useTranslations()
  const { isHomepage } = useHeaderContext()

  if (isHomepage) {
    return [
      {
        id: 'downloadable-assets' as NavItemType,
        name: t('navigation.downloadable_assets'),
        link: '/',
      },
    ]
  }

  return getMarketplaceNavItems(t)
}

function getMarketplaceNavItems(t: ReturnType<typeof useTranslations>): NavItem[] {
  const navItems: NavItem[] = [
    {
      id: 'freebies',
      name: t('navigation.freebies.freebies'),
      link: '/freebies/',
      subMenuItems: [
        {
          name: t('navigation.freebies.fonts'),
          link: '/freebies/free-fonts/',
        },
        {
          name: t('navigation.freebies.svgs'),
          link: '/freebies/free-crafts/',
        },
        {
          name: t('navigation.freebies.graphics'),
          link: '/freebies/free-graphics/',
        },
        {
          name: t('navigation.freebies.embroidery'),
          link: '/freebies/free-embroidery-designs/',
        },
        {
          name: t('navigation.freebies.classes'),
          link: '/freebies/free-classes/',
        },
        {
          name: t('navigation.freebies.3d_svgs'),
          link: '/freebies/free-3d-svg/',
        },
        {
          name: t('navigation.freebies.knitting'),
          link: '/freebies/free-knitting/',
        },
        {
          name: t('navigation.freebies.laser_cutting'),
          link: '/freebies/free-laser-cutting/',
        },
        {
          name: t('navigation.freebies.3d_printing'),
          link: '/freebies/free-3d-printing/',
        },
        {
          name: t('navigation.gifts.gifts'),
          link: AppRoutes.DAILY_GIFTS,
          icon: <IconFeaturedSeasonalAndGifts className="h-5 w-5" />,
        },
        {
          name: t('navigation.freebies.browse_all'),
          link: '/freebies/',
        },
      ],
    },
  ]

  return navItems
}
